/**
 *  All api related to Categories
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchCategories(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchCategories',
    () => source.cancel('fetchCategories: Operation cancelled by user')
  )
  return OmnitechApi
    .request({
      endpoint: 'categories',
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: options.arrayFormat,
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ cacheChecksum, data }) => ({
      categories: data.categories,
      next: _.get(data, 'categoriesPagination.nextPage') > page
        ? () => fetchCategories({
          page: page + 1,
          ...others
        })
        : null,
      all: page === 1 && _.get(data, 'categoriesPagination.nextPage') > 1
        ? () => Promise.all(
          _.times(
            _.get(data, 'categoriesPagination.totalPages') - 1,
            (index) => fetchCategories({
              pageCountless: true,
              page: index + 2,
              ...others
            }),
          ),
        )
        : null,
      count: _.get(data, 'categoriesPagination.totalCount'),
      cacheChecksum: _.get(cacheChecksum, 'categoriesValue'),
    }))
}

export function fetchCategoryByCode({ code, ...params }) {
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchCategoryByCode',
    () => source.cancel('fetchCategoryByCode: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `categories/by_code/${code}`,
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: 'brackets',
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      category: _.get(data, 'category', {})
    }))
}
